import axios from "axios";
import {
  getHeaders,
  checkStatus,
} from "../../../../Services/SharedSevices/SharedServices";
import axiosInstance from "../../../../Services/Global-Services/UnauthorizedTokenHandler";
const baseURL = process.env.REACT_APP_BASE_URL;

//For Get Exit Employee List Data ...
export const getEmployeeDetailsData = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Exit/List`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// For add initiate Employee Details
export const addinitiateEmployeeDetails = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Exit/AddInitiateExit`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

//For Get Exit Employee List Data ...
export const addEmployeeRequestForClarification = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Exit/UpdateRequestClarification`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

//For Update Request clarification List Data ...
export const updateRequestForClarification = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Exit/UpdateRequestClarification`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

//For Update Request clarification List Data ...
export const addClarificationAssignment = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Exit/AddClarificationAssignment`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

//For Get Exit Employee List Data ...
export const updateEmployeeStatus = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Exit/UpdateKeyRequest`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export const GetSummaryCards = async () => {
   try {
    const response = await axiosInstance.post(`${baseURL}/Exit/Summary`, null, {
      headers: await getHeaders()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}